var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class:
        _vm.isCollapse === ""
          ? "footer"
          : _vm.isCollapse === "t"
          ? "footer isCollapse"
          : "footer noCollapse",
    },
    [
      _c("p", {
        staticClass: "footer-info",
        domProps: {
          innerHTML: _vm._s(`© ${_vm.getYear()}${_vm.$t("FOOTER_DES")}`),
        },
      }),
      _c("div", { staticClass: "footer-version" }, [_vm._v("v2.2.0")]),
      _c("ul", { staticClass: "footer-bar" }, [
        _c("li", { domProps: { innerHTML: _vm._s(_vm.$t("FOOTER_LEGAL")) } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }